/* eslint-disable react-hooks/exhaustive-deps */
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import { Box } from "@mui/material";
import i18next from 'i18next';
import { useEffect, useState } from "react";
import Countdown from 'react-countdown';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../../constants/appRoutes";
import { WBTextType } from '../../../constants/welcomeBonusTextTypes';
import { buildLocalizeRoute } from "../../../helpers/languageHelper";
import { ObjectNameFormatter } from '../../../helpers/objectNameFormatter';
import { convertToHours } from '../../../helpers/welcomeBonusTimeHelper';
import { getUser } from "../../../services/authService";
import { UserService } from "../../../services/userService";
import { Toaster } from "../common/toaster";
import { ButtonWrapper } from "../formUtilities/useButton";
import { TextWrapper } from '../formUtilities/useTextWrapper';

const sprintDate = process.env.REACT_APP_ENV === 'prod' ? '2025-02-24' : '2025-02-22';

export const CashbackBanner = () => {
  const { t } = useTranslation();
  const userService = new UserService();
  const [welcomeBonus, setWelcomeBonus] = useState(null);
  const { settings } = useSelector(
    (state) => state.systemSettingsDataReducer
  );
  const [loading, setLoading] = useState(true);
  const [coupon, setCoupon] = useState(null);
  const [isAllDocUploaded, setIsAllDocUploaded] = useState(false);
  const [isTimeExpired, setIsTimeExpired] = useState(false);
  const navigate = useNavigate();
  const user = getUser();

  const [targetDate, setTargetDate] = useState(null);

  const isNewUser = () => {
    if (!user?.signUpDate) {
      return false;
    }

    return new Date(user?.signUpDate) >= new Date(sprintDate); //sprint 83 deployment date;
  };

  useEffect(() => {
    if (settings && settings?.enabledWelcomeBonus) {
      setWelcomeBonus(ObjectNameFormatter(JSON.parse(settings?.enabledWelcomeBonus)));
    }
  }, [settings]);

  useEffect(() => {
    if (isNewUser() && welcomeBonus?.enabled) {
      getDocumentUploadStatus();
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  }, [welcomeBonus]);

  const handleCopy = () => {
    navigator.clipboard.writeText(coupon?.code);
    Toaster({ msg: "Copied...", isError: false });
  };

  const isApprovedAndUploaded = () => {
    return user?.isApproved && isAllDocUploaded;
  };

  const getCouponList = () => {
    return userService.getCouponList();
  };

  const getDocumentUploadStatus = () => {
    userService.getDocumentStatus().then(async resp => {
      const hasUploadedAllDocuments = resp.data?.hasUploadedAllDocuments;
      setIsAllDocUploaded(hasUploadedAllDocuments);
      const time = convertToHours(welcomeBonus?.documentsUploadedMaxOffset || '2.00:00:00') || 48;
      let date = new Date(`${user?.signUpDate}T00:00:00.000Z`);
      let utcTime = date.getTime();
      date.setTime(utcTime + time * 60 * 60 * 1000);
      setTargetDate(date);
      if (hasUploadedAllDocuments) {
        if (user?.isApproved) {
          const couponList = await getCouponList();
          const promoCode = couponList.data[0] || null;
          setCoupon(promoCode);
          if (promoCode?.expiryDate) {
            date = new Date(promoCode?.expiryDate);
            // utcTime = date.getTime();
            // console.log(utcTime);
            // date.setTime(utcTime * 24 * 60 * 60 * 1000);
          }
          setLoading(false);
          setTargetDate(date);
        } else {
          setLoading(false);
          setTargetDate(null);
        }
      } else {
        setLoading(false);
      }
    }).catch(err => {
      setLoading(false);
    });
  };


  if (!isNewUser() || isTimeExpired || loading || (user?.isApproved && !coupon?.code) || !welcomeBonus?.enabled) {
    return <></>;
  }

  const getCountdownSection = (value, label) => {
    return <Box className='flex flex-col items-center justify-center gap-1'>
      <Box sx={{
        backdropFilter: 'blur(6px)',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.06) 100%)',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.18), 0 1px 2px rgba(0,0,0,0.25)'
      }} className='!text-white text-[15px] font-bold tabular-nums w-[34px] h-[34px] rounded-lg ring-1 ring-white/15 flex justify-center items-center'>{String(value).padStart(2, '0')}</Box>
      <Box className='!text-white/70 !text-[8px] !font-medium tracking-wider text-center uppercase'>{t(label)}</Box>
    </Box>;
  };
  const countdownSeparator = <Box className='!text-white/40 mx-1.5 font-bold relative -top-[8px] text-[14px]'>:</Box>;

  const getCurrentHeadingAndIcon = () => {
    let headingAndIcon = { heading: "", subText: "", icon: null };
    if (!isAllDocUploaded) {
      headingAndIcon = {
        heading: welcomeBonus?.texts?.[`${WBTextType.docUploadBanner}_${i18next.language}`]?.title,
        subText: welcomeBonus?.texts?.[`${WBTextType.docUploadBanner}_${i18next.language}`]?.content, icon: <DiamondOutlinedIcon className='!text-secondary' />
      };
    } else if (user?.isApproved) {
      headingAndIcon = {
        heading: welcomeBonus?.texts?.[`${WBTextType.promoCodeAvailableBanner}_${i18next.language}`]?.title, subText: welcomeBonus?.texts?.[`${WBTextType.promoCodeAvailableBanner}_${i18next.language}`]?.content, icon: <CelebrationOutlinedIcon className='!text-secondary' />
      };
    } else {
      headingAndIcon = { heading: welcomeBonus?.texts?.[`${WBTextType.approvalPendingBanner}_${i18next.language}`]?.title, subText: welcomeBonus?.texts?.[`${WBTextType.approvalPendingBanner}_${i18next.language}`]?.content, icon: <AccessTimeOutlinedIcon className='!text-secondary' /> };
    }
    return headingAndIcon;
  };

  return <Box id="mp-announcement-bar" sx={{
    backgroundImage: `radial-gradient(circle at 0% 0%, rgba(0,209,117,0.35), transparent 55%), radial-gradient(circle at 100% 100%, rgba(150,236,224,0.18), transparent 50%), linear-gradient(135deg, #063236 0%, #0a3d34 50%, #0d2b22 100%)`,
    boxShadow: '0 4px 24px -8px rgba(0,209,117,0.25)'
  }} className={`sticky top-[55px] md:top-[132px] z-50 overflow-hidden min-h-[40px] rounded-md flex justify-center items-center w-full px-3 py-2 text-start !text-white !text-[14px] !font-[500]`}>
      <Box className='w-full flex md:flex-row flex-col md:items-center items-start justify-between'>
        <Box className='flex flex-row items-center'>
          <Box>
            {getCurrentHeadingAndIcon().heading ?
              <Box className='text-[14px] !font-bold'><span>{getCurrentHeadingAndIcon().heading}</span></Box>
              : null}
            {getCurrentHeadingAndIcon().subText ? <Box className='!text-[13px]'>
              {getCurrentHeadingAndIcon().subText}
            </Box> : null}
          </Box>
        </Box>
        <Box className='w-4'></Box>
        <Box className='flex flex-row items-center md:justify-start justify-between md:w-auto w-full md:mt-0 mt-2'>
          {targetDate ? <Countdown
            date={targetDate}
            intervalDelay={0}
            precision={3}
            autoStart
            onComplete={() => {
              setIsTimeExpired(true);
            }}
            renderer={({ days, hours, minutes, seconds, completed }) => {
              return completed ? null : <Box className='flex items-center'>
                {getCountdownSection(days, days > 1 ? 'days' : 'day')}
                {countdownSeparator}
                {getCountdownSection(hours, 'hours')}
                {countdownSeparator}
                {getCountdownSection(minutes, 'minutes')}
                <Box className='w-5'></Box>
              </Box>;
            }}
          /> : null}
          <Box className='mt-3 md:mt-0'>
            {!isApprovedAndUploaded() ?
              !isAllDocUploaded ? <ButtonWrapper onClick={() => {
                navigate(buildLocalizeRoute(`${AppRoutes.Investor}/${AppRoutes.Profile}/${AppRoutes.IProfileUpdate}`));
              }} labelClass="!text-investor-deep !font-bold !tracking-wide" classList="!bg-gradient-to-b !from-[#00E082] !to-[#00B564] !border-0 !rounded-lg !px-5 !shadow-[inset_0_1px_0_rgba(255,255,255,0.35),inset_0_-1px_0_rgba(0,0,0,0.1),0_4px_16px_-4px_rgba(0,209,117,0.55)] hover:!shadow-[inset_0_1px_0_rgba(255,255,255,0.4),inset_0_-1px_0_rgba(0,0,0,0.1),0_6px_22px_-4px_rgba(0,209,117,0.75)] hover:!from-[#00E88B] hover:!to-[#00C46E] !transition-all" label={t('completeSignUpBonus')} /> :
                <TextWrapper classList='!text-[13px] !font-[500]' text={t('accountUnderReview')} />
              : coupon ?
                <Box onClick={() => {
                  handleCopy();
                }} className={`flex items-center text-[13px] rounded-md cursor-pointer border px-3 relative py-1 border-dashed border-[#ccc] hover:opacity-80`}>
                  <ContentCopyOutlinedIcon className="!text-[16px] mx-1" />
                  <Box className='font-bold'>{t('copyCode')}</Box>
                </Box> : null
            }
          </Box>
        </Box>
      </Box>
  </Box>;
};